import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';
import styled from 'styled-components';
export const MainContainer = styled(motion.div).withConfig({
  displayName: "MainMenuMobilestyle__MainContainer",
  componentId: "sc-c72nqt-0"
})(["", " box-shadow:0px 0px 0px 0px rgba(0,0,0,0.05),0px 1px 3px 0px rgba(0,0,0,0.05),0px 5px 5px 0px rgba(0,0,0,0.04),0px 11px 7px 0px rgba(0,0,0,0.03),0px 20px 8px 0px rgba(0,0,0,0.01),0px 31px 9px 0px rgba(0,0,0,0.00);"], {
  "position": "fixed",
  "left": "0px",
  "right": "0px",
  "top": "0px",
  "zIndex": "48",
  "height": "100vh !important",
  "overflowY": "scroll",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
});
export const WrapperFixedHeight = styled.div.withConfig({
  displayName: "MainMenuMobilestyle__WrapperFixedHeight",
  componentId: "sc-c72nqt-1"
})(["", ""], {
  "height": "fit-content !important",
  "padding": "1rem"
});
export const ListContainerAnimation = styled(motion.div).withConfig({
  displayName: "MainMenuMobilestyle__ListContainerAnimation",
  componentId: "sc-c72nqt-2"
})(["", ""], {
  "zIndex": "50",
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.75rem"
});
export const MainMenuList = styled(motion.li).withConfig({
  displayName: "MainMenuMobilestyle__MainMenuList",
  componentId: "sc-c72nqt-3"
})(["", ""], {
  "zIndex": "50",
  "marginBottom": "0.25rem",
  "display": "flex",
  "justifyContent": "space-between"
});
export const WrapperDivier = styled(motion.li).withConfig({
  displayName: "MainMenuMobilestyle__WrapperDivier",
  componentId: "sc-c72nqt-4"
})(["", ""], {
  "marginTop": "0.25rem",
  "marginBottom": "0.25rem",
  "display": "flex",
  "alignItems": "center"
});
export const Divider = styled(motion.div).withConfig({
  displayName: "MainMenuMobilestyle__Divider",
  componentId: "sc-c72nqt-5"
})(["", ""], {
  "height": "1px",
  "width": "100%",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(235 235 235 / var(--tw-border-opacity, 1))"
});
export const MenuTitle = styled.div.withConfig({
  displayName: "MainMenuMobilestyle__MenuTitle",
  componentId: "sc-c72nqt-6"
})(["", ""], {
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
});
export const CloseIcon = styled(Image).withConfig({
  displayName: "MainMenuMobilestyle__CloseIcon",
  componentId: "sc-c72nqt-7"
})(["", ""], {
  "width": "18px",
  "cursor": "pointer"
});
export const WrapperBottomMenu = styled(motion.li).withConfig({
  displayName: "MainMenuMobilestyle__WrapperBottomMenu",
  componentId: "sc-c72nqt-8"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.25rem",
  "padding": "0.5rem",
  "paddingBottom": "1.5rem !important"
});
export const WrapperMenuLink = styled(motion.div).withConfig({
  displayName: "MainMenuMobilestyle__WrapperMenuLink",
  componentId: "sc-c72nqt-9"
})(["", " a{", " &.active{", "}}"], {
  "marginLeft": "0.5rem",
  "marginRight": "0.5rem",
  "marginTop": "0.25rem",
  "marginBottom": "0.25rem",
  "display": "flex"
}, {
  "width": "fit-content",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
});
export const OptionMenu = styled(Link).withConfig({
  displayName: "MainMenuMobilestyle__OptionMenu",
  componentId: "sc-c72nqt-10"
})(["", " span{", "}&:active{", "}"], {
  "fontWeight": "400 !important"
}, {
  "marginLeft": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(238 132 60 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
});